import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import React from "react";


export const BannerComponent = ()=> {


    return(
        <>
            <div className={"w-full pt-0 mx-auto"} style={{maxWidth:"1500px"}}>
                <div className={"w-full md:w-11/12 mx-auto block md:flex "}>
                    <div className="w-full md:w-5/12 relative">
                        <div className="relative w-full h-img-banner overflow-hidden">
                            <img
                                src="./assets/POSTER.png"
                                alt="Product"
                                className="h-full w-full object-contain clip-custom"
                            />
                            <div className="absolute md:hidden z-30 -bottom-0 md:bottom-10 left-2 bg-black bg-opacity-50 text-white px-4 py-2 rounded">
                                <p className="text-md text-gray-200 md:text-lg font-bold">SCROLL DOWN</p>
                                <p className="text-sm text-gray-300">and view products</p>
                            </div>
                        </div>
                    </div>

                    <div className={"w-full md:w-7/12 "}>
                        <div className={"w-5/12 md:w-full ms-auto"}>
                            <div className={"bg-main-s py-2 md:py-3"}></div>
                        </div>
                        {/*<div className={"w-5/12 md:w-full me-auto"}>*/}
                        {/*    <div className={"bg-main-s py-4 md:py-5"}></div>*/}
                        {/*</div>*/}
                        <div className={"w-11/12 pt-3 pb-1  mb-4 md:mb-10 md:w-10/12 mx-auto"}>
                            <div className={"mt-3 md:mt-8"}>
                                <div className={""}>

                                </div>
                                <div className={""}>
                                    <div className={"text-sm"}>
                                        <h3 className={"text-main font-semibold"}>C H E C K W E I G H E R</h3>
                                    </div>
                                </div>
                                <div className={"mt-3 mb-3 md:mt-2 md:mb-3"}>
                                    <div className={""}>
                                        <h1 className={"text-main-home font-semibold text-2xl md:text-4xl"}>
                                            UNIMAX : Checkweigher dan Metal Detector
                                        </h1>
                                    </div>
                                    <div className={"mt-3 md:mt-3 md:mb-6  mb-3"}>
                                        <p className={"text-gray-800 text-md font-extralight "}>
                                            Unimax adalah Global Brand berorientasi teknologi modern yang mengintegrasikan produksi, penelitian dan pengembangan, penjualan dan layanan.
                                        </p>
                                    </div>
                                    <div className={"my-4"}>
                                        <button className={"btn-main py-2 px-4"}>
                                            <div className={"flex gap-4"}>
                                                <div className={""}>
                                                    <p className={"text-md font-normal"}>Explorasi sekarang</p>
                                                </div>
                                                {/*<div className={"h-6"}>*/}
                                                {/*    <img className={"h-full"} src={"assets/icon/icon-arrow.svg"} />*/}
                                                {/*</div>*/}
                                            </div>
                                        </button>
                                    </div>
                                    <div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"w-5/12 md:w-full me-auto"}>
                            <div className={"bg-main-s py-2 md:py-3"}></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export const  BannerImageComponent = () => {
    return(
        <>

            <div className={"w-full pt-0  mx-auto"} >
                <div className={"w-full  mx-auto block md:flex "}>
                    <div className="w-full mx-auto  mb-4  relative">
                        <div className="relative w-full mx-auto my-0  h-img-banner-2 overflow-hidden">
                            <img
                                src="./assets/bann/banner-4.jpg"
                                alt="Product"
                                className="h-full w-full rounded-2xl object-cover clip-custom"
                            />
                            <div className=" mx-auto absolute  z-30 top-0 w-full h-full left-0 bg-black bg-opacity-70 text-white px-2 md:px-4 py-2 rounded">
                                <div style={{maxWidth:"1500px"}} className={"w-11/12 relative h-full mx-auto"}>
                                    <div  style={{maxWidth:"1500px"}}  className={"mx-auto  absolute top-32 md:top-40"}>
                                        <div  style={{maxWidth:"1500px"}} className={"mx-auto 5xl:w-11/12 "}>
                                            <div className={"mt-20"}>
                                                <h1 className="text-3xl sm:text-4xl lg:text-5xl text-gray-50 font-medium">X-Ray dengan Presisi Maksimal</h1>
                                                <div className={"my-3"}>
                                                    <h1 className="text-md sm:text-lg md:text-xl lg:text-2xl text-gray-200">Solusi inovatif untuk inspeksi produk yang akurat dan memastikan keamanan tanpa kompromi.</h1>
                                                </div>
                                            </div>
                                            <div className={"w-72 my-10"}>
                                                <Link to={"/catalog"}>
                                                    <button className={"md:text-md text-md border hover:bg-white cursor-pointer hover:text-gray-700  border-gray-50 rounded-full py-3 px-5 "}>
                                                        Temukan X-Ray anda
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className={"absolute right-14 z-30 bottom-10"}>
                                <div className={"h-32 w-32"}>
                                    <img src={"/assets/icon/icon-garansi.svg"} className={"w-full object-cover "}/>
                                </div>
                            </div>
                        </div>
                        <div className={"w-full absolute md:w-full "}>
                            <div className={"w-5/12 md:w-full ms-auto"}>
                                <div className={"bg-main-s py-2 md:py-3"}></div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}
